module.exports = __webpack_public_path__ + "static/young-leader-photo-garrett_blaize-8880117c1be159d4e0841f7d0d2d84b2.jpg";